import { render, staticRenderFns } from "./SpackageCatalogEdit.vue?vue&type=template&id=490ce46e&"
import script from "./SpackageCatalogEdit.vue?vue&type=script&lang=js&"
export * from "./SpackageCatalogEdit.vue?vue&type=script&lang=js&"
import style0 from "./SpackageCatalogEdit.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports